<template>
    <div>
        <!-- <div v-for="(list, index) in statusType" :key="index"> -->
        <span class="alerts-actions-views" :class="statusClass">
            <i :class="statusIcon"></i>
        </span>
        <!-- </div> -->
    </div>
</template>

<script>
export default {
    components: {},

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        data: {
            type: Object,
            default: null,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        statusIcon() {
            const documentInfo = this.data.customer.documentInfo;
            const documentationStatus = this.data.documentationStatus;

            if (documentationStatus == 'mis_matched' || documentationStatus == 'expired' || documentationStatus == 'expiredIn') {
                return 'icon-cross-with-circle'
            }
            else if (!documentInfo.fieldEmiratesID.fileName && !documentInfo.identity.fileName && !documentInfo.licenseFront.fileName) {
                return 'icon-warning'
            }

            return 'icon-tick-with-circle'
        },
        statusClass() {
            const documentInfo = this.data.customer.documentInfo;
            const documentationStatus = this.data.documentationStatus;

            if (documentationStatus == 'mis_matched' || documentationStatus == 'expired' || documentationStatus == 'expiredIn') {
                return 'danger'
            }
            else if (!documentInfo.fieldEmiratesID.fileName && !documentInfo.identity.fileName && !documentInfo.licenseFront.fileName) {
                return 'medium'
            }

            return 'low'
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() { }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {}, // End of Component > mounted
} // End of export default
</script>
